import { render, staticRenderFns } from "./Exports2.vue?vue&type=template&id=63799d14&"
import script from "./Exports2.vue?vue&type=script&lang=js&"
export * from "./Exports2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports